import { useMemo } from "react";
import { getGoalsByUser, getRoutinesByUser, useQuery } from "wasp/client/operations";
import type { RoutineCompletion, TradingRoutine } from "wasp/entities";
import type { GoalWithHistory } from "../../trading-goals/operations";
import { activeGoals, completedGoals, dailyPnlGoal, routineStreak, todayChecklist } from "../lib/discipline";

export type LiteRoutine = TradingRoutine & { routineCompletions: RoutineCompletion[] };

// Tableau vide stable : `data ?? []` créerait une nouvelle référence à chaque rendu et casserait le useMemo.
const NONE: never[] = [];

/**
 * Routines et objectifs du Lite : mêmes queries que l'Advanced, dérivés calculés ici.
 * React Query déduplique entre la page, la TodayCard, la checklist et les stats.
 */
export function useLiteDiscipline() {
  const routinesQ = useQuery(getRoutinesByUser);
  const goalsQ = useQuery(getGoalsByUser);
  const routines: LiteRoutine[] = routinesQ.data ?? NONE;
  const goals: GoalWithHistory[] = goalsQ.data ?? NONE;

  const derived = useMemo(() => ({
    today: todayChecklist(routines),
    streak: routineStreak(routines),
    active: activeGoals(goals),
    completed: completedGoals(goals),
    dailyPnlGoal: dailyPnlGoal(goals),
  }), [routines, goals]);

  return {
    routines,
    goals,
    loading: routinesQ.isLoading || goalsQ.isLoading,
    // Une query en erreur n'est pas « aucune routine » : le consommateur décide quoi afficher.
    error: routinesQ.error ?? goalsQ.error ?? null,
    ...derived,
  };
}
